import React, { useState, useEffect } from 'react';
import { Box, Button, Dialog, TextField, withStyles } from '@material-ui/core';
import { DatePicker } from '@material-ui/pickers';
import moment from 'moment-timezone';
import {injectIntl} from "react-intl";

import messages from './messages'
import styles from '../styles';

const DateTimePicker = props => {
  const {
    availableDays,
    classes,
    closePicker,
    formikProps,
    intl: { formatMessage },
    onConfirm,
    open,
    initialValue,
    name,
    selectedTimeZoneData: { time_zone, service_location },
  } = props;
  const { setFieldValue, values } = formikProps;

  const initialSelectedDate = () => {
    let initialSelectedDate = moment();
    if (initialValue) {
      initialSelectedDate = initialValue;
    } else if (availableDays) {
      initialSelectedDate = moment(availableDays[0]);
    }
    return initialSelectedDate;
  };

  const [selectedDate, setSelectedDate] = useState(initialSelectedDate);
  const [selectedTime, setSelectedTime] = useState();

  const enableAvailableDays = date => {
    const dateAvailable = availableDays.find(day => moment(date).format('YYYY-MM-DD') === day);
    return !dateAvailable;
  };

  useEffect(() => {
    const roundToNearestHour = () => {
      const duration = moment.duration(30, 'minutes');
      const currentTime = moment(Math.ceil(+moment() / +duration) * +duration);
      return currentTime.tz(time_zone).format('HH:mm');
    };
    setSelectedTime(
      initialValue ? initialValue.tz(time_zone).format('HH:mm') : roundToNearestHour()
    );
  }, [service_location, initialValue, time_zone]);

  const clickCancelButton = () => {
    if (values[name]) {
      closePicker();
      if (values[name] !== selectedDate) {
        setSelectedDate(values[name]);
        setSelectedTime(values[name].format('HH:mm'));
      }
    } else {
      closePicker();
      setFieldValue('ride_time', 'now');
    }
  };

  const clickConfirmButton = () => {
    const confirmedTime = moment.tz(
      selectedDate.format('YYYY-MM-DD') + ' ' + selectedTime,
      time_zone
    );
    setFieldValue(name, confirmedTime);
    closePicker();
    onConfirm(confirmedTime);
  };

  const timePickerTitle=`${formatMessage(messages.scheduledTime)} (${service_location})`;

  return (
    <Dialog
      classes={{ scrollPaper: classes.datePicker }}
      onBackdropClick={clickCancelButton}
      onEscapeKeyDown={clickCancelButton}
      open={open}
    >
      <DatePicker
        autoOk
        disableToolbar
        onChange={e => setSelectedDate(e)}
        openTo="date"
        shouldDisableDate={enableAvailableDays}
        value={selectedDate}
        variant="static"
      />
      <Box pl={3} pr={3} pb={2}>
        <TextField
          fullWidth
          label={timePickerTitle}
          onChange={e => setSelectedTime(e.target.value)}
          inputProps={{ step: 300 }}
          type="time"
          value={selectedTime}
        />
      </Box>
      <Box p={2} className={classes.datePickerButtons}>
        <Button color="primary" onClick={clickCancelButton} variant="outlined">
          {formatMessage(messages.cancel)}
        </Button>
        <Button
          color="primary"
          className={classes.confirmButton}
          onClick={clickConfirmButton}
          variant="contained"
        >
          {formatMessage(messages.confirm)}
        </Button>
      </Box>
    </Dialog>
  );
};

export default withStyles(styles)(injectIntl(DateTimePicker));
